module.exports = __webpack_public_path__ + "static/20-04e67c926c1c478c99cf9e8317d6ad28.png";